// src/index.jsx
import React from 'react'
import ReactDOM from 'react-dom/client'
import { GoogleOAuthProvider } from '@react-oauth/google'

import App from './App'
import './index.css'

import { registerLicense } from '@syncfusion/ej2-base'

// 1) Log the key length and call register (should be a long string, often > 200 chars)
const key = import.meta.env.VITE_APP_SYNCFUSION_KEY || ''
console.log('SYNCFUSION_KEY length:', key.length)
try {
  registerLicense(key)
  console.log('registerLicense() called')
} catch (e) {
  console.error('registerLicense() threw:', e)
}

// 2) After first paint, detect the trial banner in the DOM
// (Syncfusion shows a visible message when the license is missing/invalid)
requestAnimationFrame(() => {
  // Give components a tick to render
  setTimeout(() => {
    const text = document.body.innerText || ''
    if (/trial version of Syncfusion/i.test(text)) {
      console.error('Syncfusion trial banner detected → license NOT applied')
    } else {
      console.log('No Syncfusion trial banner detected → license applied')
    }
  }, 300)
})


ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={import.meta.env.VITE_APP_GOOGLE_CLIENT_ID || ''}>
      <App />
    </GoogleOAuthProvider>
  </React.StrictMode>
)
